// Simple script to test localization
import React, { useState } from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import translations from './utils/translations';

const LocaleSelector = () => {
  const [currentLocale, setCurrentLocale] = useState('en');
  
  const availableLocales = Object.keys(translations);
  
  return (
    <div style={{ padding: '20px' }}>
      <div style={{ marginBottom: '20px' }}>
        <label style={{ marginRight: '10px', fontWeight: 'bold' }}>Select Locale:</label>
        <select 
          value={currentLocale} 
          onChange={(e) => setCurrentLocale(e.target.value)}
          style={{ padding: '5px 10px' }}
        >
          {availableLocales.map(locale => (
            <option key={locale} value={locale}>{locale.toUpperCase()}</option>
          ))}
        </select>
      </div>
      
      <div style={{ border: '1px solid #ddd', borderRadius: '8px', padding: '20px' }}>
        <App current_locale={currentLocale} />
      </div>
    </div>
  );
};

// For testing purposes only
if (document.getElementById('locale-test-root')) {
  ReactDOM.render(<LocaleSelector />, document.getElementById('locale-test-root'));
}

export default LocaleSelector;
